import { useTheme } from "@/components/ThemeProvider";

/**
 * Sprintroll full logo lockup (isotype + wordmark). Automatically swaps
 * between the white variant (for dark backgrounds) and the black variant
 * (for light backgrounds) based on the current theme.
 *
 *   <SprintrollLogo className="h-8 w-auto" />
 *
 * For fixed-background surfaces (e.g., a dark gradient regardless of theme),
 * pass `variant="light" | "dark"` explicitly to override the auto choice.
 */
export default function SprintrollLogo({
  className = "h-7 w-auto",
  variant,          // "light" | "dark" | undefined (auto)
  alt = "Sprintroll",
}) {
  const { theme } = useTheme();
  const resolved = variant || (theme === "dark" ? "light" : "dark");
  const src = resolved === "light" ? "/logo_blanco.png" : "/logo_negro.png";
  return (
    <img
      src={src}
      alt={alt}
      loading="eager"
      decoding="async"
      className={className}
      data-testid="sprintroll-logo"
    />
  );
}
